/**
 * This formats an amount
 *
 * @param {Number} number - the amount number
 * @param {String} currency - the amount currency
 *
 * @example
 * @click.prevent="handleScrollTo('#faq')"
 */
export const getFormattedAmount = (number, currency) => {
    if (!currency) {
        return number
    }
    return new Intl.NumberFormat('en', { style: 'currency', currency }).format(number)
}
